import React from "react";
import ServiceBody from "../MainServicePage/ServiceBody";
import { backend_data } from "../ServicesDisplayPage/servicesData";

const Check_backend = () => {
  // Pick the correct service from servicesData.js
  const service_steps = {
    data: backend_data,
    title: "Backend Development",
    description: "Learn Backend Development with Node.js, Express & Databases",
    registerPath: "/Register_back",
  };

  return (
    <>
      <ServiceBody service_steps={service_steps} />
    </>
  );
};

export default Check_backend;
